/**
 * Chain adapter
 */
var Chain = /** @class */ (function () {
    function Chain(config) {
        this.adapters = config.adapters;
    }
    Chain.prototype.log = function (msgs, level) {
        var isSuccess = true;
        this.adapters.forEach(function (adapter) {
            isSuccess = isSuccess && adapter.log(msgs, level);
        });
        return isSuccess;
    };
    return Chain;
}());
export default Chain;
//# sourceMappingURL=Chain.js.map